import React from 'react';
import PropTypes from 'prop-types';
import { Header, Footer } from '@vp/esi-bookends';
import {
  MY_ACCOUNT_PAGE_SECTION,
  MY_ACCOUNT_PAGE_STAGE,
} from '../../../constants/orderdetailsui';

export const BookendsHeader = ({ bookendsConfig, pageName }) => {
  if (!bookendsConfig) {
    return null;
  }

  const { headerType, hideSearch, hideVat, hideCart, tenant, locale } =
    bookendsConfig;

  const trackingConfiguration = {
    pageSection: MY_ACCOUNT_PAGE_SECTION,
    pageStage: MY_ACCOUNT_PAGE_STAGE,
    pageName,
  };

  return (
    <Header
      locale={locale}
      tenant={tenant}
      type={headerType}
      hideSearch={hideSearch}
      hideVat={hideVat}
      trackingConfiguration={trackingConfiguration}
      useMiniCart={!hideCart}
    />
  );
};

BookendsHeader.propTypes = {
  bookendsConfig: PropTypes.object.isRequired,
  pageName: PropTypes.string.isRequired,
};

export const BookendsFooter = ({ bookendsConfig, pageName }) => {
  if (!bookendsConfig) {
    return null;
  }

  const { footerType, tenant, locale } = bookendsConfig;

  const trackingConfiguration = {
    pageSection: MY_ACCOUNT_PAGE_SECTION,
    pageStage: MY_ACCOUNT_PAGE_STAGE,
    pageName,
  };

  return (
    <Footer
      locale={locale}
      tenant={tenant}
      type={footerType}
      trackingConfiguration={trackingConfiguration}
    />
  );
};

BookendsFooter.propTypes = {
  bookendsConfig: PropTypes.object.isRequired,
  pageName: PropTypes.string.isRequired,
};
